import './MatchHeader.css';

interface MatchHeaderProps {
  matchId: string;
}

export function MatchHeader({ matchId }: MatchHeaderProps) {
  return (
    <header className="match-header">
      <h1 className="match-title">Partida {matchId}</h1>
    </header>
  );
}
